
import React, { useState, useEffect, useMemo, useRef } from 'react';
import styles from '../../styles/MateriasStyles/PantallaDeTareas.v2.module.css';
import Pagination from '../../components/Pagination.tsx';
import { getBecas } from '../../api/becas';

const BecasTable = ({ refreshTrigger, onView, onEdit, onDelete, query = "" }) => {
  const [becas, setBecas] = useState([]);
  const [loading, setLoading] = useState(true);
  // ...existing code...

  useEffect(() => {
    const fetchBecas = async () => {
      setLoading(true);
      try {
        const data = await getBecas();
        setBecas(Array.isArray(data) ? data : (data.results || []));
      } catch (e) {
        setBecas([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBecas();
  }, [refreshTrigger]);

  // PAGINATION
  const [page, setPage] = useState(1);
  const pageSize = 8;
  // Filtrar becas por query en vivo
  const becasFiltradas = query
    ? becas.filter(b =>
        (b.nombre || '').toLowerCase().includes(query.toLowerCase()) ||
        (b.tipo_de_beca || '').toLowerCase().includes(query.toLowerCase()) ||
        (b.seccion || '').toLowerCase().includes(query.toLowerCase())
      )
    : becas;
  const totalPages = Math.max(1, Math.ceil(becasFiltradas.length / pageSize));
  const paginated = becasFiltradas.slice((page - 1) * pageSize, page * pageSize);

  // Reiniciar página si cambia la lista
  const becasKey = useMemo(() => (becas || []).map(b => b.id).sort().join(','), [becas]);
  const prevBecasKeyRef = useRef(becasKey);
  useEffect(() => {
    if (prevBecasKeyRef.current !== becasKey) {
      setPage(1);
      prevBecasKeyRef.current = becasKey;
    }
  }, [becasKey]);
  useEffect(() => {
    if (page > totalPages && totalPages > 0) setPage(totalPages);
  }, [page, totalPages]);

  // Formatear fecha
  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Botones de acción igual que materias
  const ActionButtons = ({ beca }) => (
    <div className={styles.actionButtons}>
      <button aria-label="Ver detalles" className={styles.actionButton} onClick={() => onView && onView(beca)}>
        <img
          src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/a1782ac5b190a9d29d8f798383eedda3f294d56b?placeholderIfAbsent=true"
          alt="Ver"
          className={styles.actionIcon}
        />
      </button>
      <button aria-label="Editar" className={styles.actionButton} onClick={() => onEdit && onEdit(beca)}>
        <img
          src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/83eacec9f1f974b33615bbc95aea7ff7b2d13b0e?placeholderIfAbsent=true"
          alt="Editar"
          className={styles.actionIcon}
        />
      </button>
      <button aria-label="Eliminar" className={styles.actionButton} onClick={() => onDelete && onDelete(beca)}>
        <img
          src="https://api.builder.io/api/v1/image/assets/189f954e013f4fa084ccafbef336b287/bef20ed4bd5293db48e37df8e511dca0fed7db2e?placeholderIfAbsent=true"
          alt="Eliminar"
          className={styles.actionIcon}
        />
      </button>
    </div>
  );

  if (loading) {
    return (
      <div className={styles.tableContainer}>
        <div className={styles.tableHeader}>
          <div className={styles.tableTitle}>
            <div className={styles.tableTitleIcon}>
              <div className={styles.iconContainerOrange}>
                <span>🎓</span>
              </div>
            </div>
            <h2 className={styles.tableTitleText}>Becas</h2>
          </div>
        </div>
        <div className={styles.tableHeaderRow}>
          <div className={styles.columnHeader}><span>Nombre</span></div>
          <div className={styles.columnHeader}><span>Tipo</span></div>
          <span className={styles.columnHeaderWide}>% Máximo</span>
          <span className={styles.columnHeader}>Campus</span>
          <span className={styles.columnHeader}>Sección</span>
          <div className={styles.columnHeader}><span>Estado</span></div>
          <span className={styles.columnHeaderWide + ' ' + styles.stickyActionsHeader}>Acciones</span>
        </div>
        <div style={{ padding: '20px', textAlign: 'center' }}>Cargando becas...</div>
      </div>
    );
  }

  if (!paginated.length) {
    return (
      <div className={styles.tableContainer}>
        <div className={styles.tableHeader}>
          <div className={styles.tableTitle}>
            <div className={styles.tableTitleIcon}>
              <div className={styles.iconContainerOrange}>
                <span>🎓</span>
              </div>
            </div>
            <h2 className={styles.tableTitleText}>Becas</h2>
          </div>
        </div>
        <div className={styles.tableHeaderRow}>
          <div className={styles.columnHeader}><span>Nombre</span></div>
          <div className={styles.columnHeader}><span>Tipo</span></div>
          <span className={styles.columnHeaderWide}>% Máximo</span>
          <span className={styles.columnHeader}>Campus</span>
          <span className={styles.columnHeader}>Sección</span>
          <div className={styles.columnHeader}><span>Estado</span></div>
          <span className={styles.columnHeaderWide + ' ' + styles.stickyActionsHeader}>Acciones</span>
        </div>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          {'No hay becas registradas.'}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.tableContainer} style={{ position: 'relative', minHeight: '320px', zIndex: 1 }}>
      <div className={styles.tableHeader}>
        <div className={styles.tableTitle}>
          <div className={styles.tableTitleIcon}>
            <div className={styles.iconContainerOrange}>
              <span>🎯</span>
            </div>
          </div>
          <h2 className={styles.tableTitleText}>Becas</h2>
        </div>
      </div>

      <div className={styles.tableHeaderRow}>
        <div className={styles.columnHeader}><span>Nombre</span></div>
        <span className={styles.columnHeader}>Tipo</span>
        <span className={styles.columnHeader}>% Máximo</span>
        <span className={styles.columnHeader}>Campus</span>
        <span className={styles.columnHeader}>Sección</span>
        <div className={styles.columnHeader}><span>Estado</span></div>
        <span className={styles.columnHeaderWide + ' ' + styles.stickyActionsHeader}>Acciones</span>
      </div>

      <div className={styles.tableBody}>
        {paginated.map((beca, index) => (
          <div key={beca.id || index} className={styles.tableRow}>
            <div className={styles.programInfo}>
              <span className={styles.programName}>{beca.nombre || '—'}</span>
            </div>
            <span className={styles.cellData}>{beca.tipo_de_beca || '—'}</span>
            <span className={styles.cellData}>{beca.porcentaje_maximo ? `${beca.porcentaje_maximo}%` : '—'}</span>
            <span className={styles.cellData}>{beca.campus_nombre || '—'}</span>
            <span className={styles.cellData}>{Array.isArray(beca.secciones_aplicables) && beca.secciones_aplicables.length > 0 ? beca.secciones_aplicables.join(', ') : beca.seccion || '—'}</span>
            <div className={styles.statusCell}>
              <div className={beca.estado === 'ACTIVO' ? styles.statusActive : styles.statusInactive}>
                <span>{beca.estado || 'INACTIVO'}</span>
              </div>
            </div>
            <div className={styles.actionButtons + ' ' + styles.stickyActionsCell}>
              <ActionButtons beca={beca} />
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <Pagination
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default React.memo(BecasTable);
